import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglenewsComponent } from './simple-icons-googlenews.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglenewsComponent ],
    exports:      [ SimpleIconsGooglenewsComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglenewsModule {}
